import { useQuery } from '@tanstack/react-query';
import getConditionTypes from 'src/services/encompass/getConditionTypes';

export const useConditionTypesQuery = (enabled = true) => {
  return useQuery({
    queryKey: ['/encompass/condition-types'] as const,
    queryFn: getConditionTypes,
    enabled,
  });
};
